import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	securityLevelFieldPlaceHolder: {
		id: 'issue-create.common.fields.security-level-field.security-level-field-place-holder',
		defaultMessage: 'Select Security Level',
		description: 'PlaceHolder text for Security level field in issue create form',
	},
});
